export const environment = {
	firebase: {
		projectId: 'vquipos',
		appId: '1:188964562916:web:12d1042ec6d26a59d209f1',
		storageBucket: 'vquipos.appspot.com',
		apiKey: 'AIzaSyAv1isqvrDkoVmzO1wtYrfkdJKlcQ_RVGo',
		authDomain: 'vquipos.firebaseapp.com',
		messagingSenderId: '188964562916',
		measurementId: 'G-0XG7LBP92J',
	},
	production: true,
	isLocalTesting: false,
	adminUrl: 'https://admin.vquiprentals.com/secure/dashboard',
	authEndPoint: 'https://api.vquiprentals.com/auth',
	paymentsEndPoint: 'https://api.vquiprentals.com/payments',
	adminEndPoint: 'https://api.vquiprentals.com/admin',
	loggingEndPoint: 'https://api.vquiprentals.com/logs',
	storageEndPoint: 'https://storage.vquiprentals.com',
	trackingEndPoint: 'https://tracking.vquiprentals.com',
	pricingEndPoint: 'https://api.vquiprentals.com/pricing',
	featuresEndPoint: 'https://api.vquiprentals.com/features',
	companyEndPoint: 'https://api.vquiprentals.com/company',
	carrierEndPoint: 'https://api.vquiprentals.com/carriers',
	productsEndPoint: 'https://api.vquiprentals.com/products',
	registrationEndPoint: 'https://api.vquiprentals.com/registration',
	reservationsEndPoint: 'https://api.vquiprentals.com/reservations',
	invoicesEndPoint: 'https://api.vquiprentals.com/invoices',
	insuranceEndPoint: 'https://api.vquiprentals.com/insurance',
	customersEndPoint: 'https://api.vquiprentals.com/customers',
	employeesEndPoint: 'https://api.vquiprentals.com/employees',
	insuranceFacilityEndpoint: 'https://api.vquipinsurance.com/facility',
	insuranceQuotesEndPoint: 'https://api.vquipinsurance.com/quotes',
	insuranceQuotesConfigEndPoint: 'https://api.vquipinsurance.com/quotes/config',
	insurancePaymentsEndPoint: 'https://api.vquipinsurance.com/payments',
	env: 'prod',
	apiKey: 'f79Jgtu3kcbZNAGX9cnx9W1DK#NFurZYdX',
	rxjs_delay: 250,
	sentryDSN: 'https://8df63f0d0e998db3384bfa52cf47cdef@o1143819.ingest.us.sentry.io/4507064960679936',
	rentalsApiEndPoint: 'https://api.vquiprentals.com/api/rentals/rentals/v1',
	manifestUrl: 'https://manifest.vquiprentals.com/prod/public/$reservationId/manifests',
};
